export class Step3 {
    constructor() {}

    intitule = 'stepper.form.mapa_in.step2';
    getprincipales = 'form.mapa_in.getprincipales';
    gettdminmax = 'form.mapa_in.gettdminmax';
    gettdtype = 'form.mapa_in.gettdtype';
	gettdlibre = 'form.mapa_in.gettdlibre';
    getspan3 = 'form.mapa_in.getspan3';
    getoui = 'form.mapa_in.getoui';
    getnon = 'form.mapa_in.getnon';
    getquantites = 'form.mapa_in.getquantites';
    add = 'boutons.addline';
    remove = 'boutons.removeline';

}
